import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl'
import PageHeader from './PageHeader.jsx'
import styles from './_errorBoundary.css'
const supportLink = 'https://support.mapmyfitness.com/'

export default class ErrorBoundary extends Component {
  static propTypes = {
    children: PropTypes.node,
    fallback: PropTypes.node,
  }

  static defaultProps = {
    fallback: (
      <div className={styles.errorMessage}>
        <PageHeader>
          <h1>
            <FormattedMessage
              id='error.layout.fallback.title'
              defaultMessage='Hold up!'
            />
          </h1>
        </PageHeader>
        <p>
          <FormattedHTMLMessage
            id='error.layout.fallback.content'
            defaultMessage='Our team is working to restore service for you as fast as possible. If you have any questions, please visit our <a href="{supportLink}">support center</a>.'
            values={{ supportLink }}
          />
        </p>
      </div>
    ),
  }

  constructor (props) {
    super(props)
    this.state = { hasError: false }
  }

  componentDidCatch () {
    this.setState({ hasError: true })
  }

  render () {
    const { fallback, children } = this.props
    return this.state.hasError ? fallback : children
  }
}
